module.exports = __webpack_public_path__ + "static/media/BC.b49069b2.png";